import { useIsomorphicLayoutEffect } from '@/hooks/useIsomorphicLayoutEffect';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { useOperationConfigModelStore } from '@/models/operation-config/operationConfig';
import {
  getHiddenTopNotificationIds,
  setHiddenTopNotificationId,
} from '@/shared/constant/local-storage/hidden-top-notification-ids/HiddenTopNotificationIds';
import { Button } from 'aui';
import { FoxIconX } from 'aui-biz-icons';
import clsx from 'clsx';
import React from 'react';
import styles from './TopNotification.module.css';

export function TopNotification() {
  const notification = useDocsDataModelStore((x) => x.notification);
  const notificationRef = React.useRef<HTMLDivElement>(null);

  const hiddenTopNotificationIds = useOperationConfigModelStore((x) => x.hiddenTopNotificationIds);
  const setHiddenTopNotificationIds = useOperationConfigModelStore(
    (x) => x.setHiddenTopNotificationIds,
  );

  React.useEffect(() => {
    const notificationElement = notificationRef.current;
    if (!notificationElement) {
      return;
    }

    const tagAList = notificationElement.querySelectorAll('a');
    tagAList.forEach((x) => {
      x.setAttribute('target', '_blank');
    });
  }, [notification]);

  useIsomorphicLayoutEffect(() => {
    const ids = getHiddenTopNotificationIds();
    if (ids.length) {
      setHiddenTopNotificationIds(ids);
    }
  }, []);

  if (!notification.length) {
    return null;
  }
  return (
    <div
      className={clsx('bg-primary text-base font-400 text-inverse', styles.notification)}
      ref={notificationRef}
    >
      {notification.map((x) => {
        return (
          <div
            className={clsx('flex w-full items-center justify-center truncate px-4 py-2', {
              ['hidden']: hiddenTopNotificationIds.includes(x.id),
            })}
            key={x.id}
          >
            <div
              className={clsx('w-0 flex-1 truncate text-center', styles['notification-text'])}
              dangerouslySetInnerHTML={{ __html: x.text }}
            />

            <Button
              aria-label="close notification"
              size="small"
              className="ml-2 h-[22px]"
              type="soft-primary"
              icon={<FoxIconX className="text-inverse" />}
              onClick={() => {
                setHiddenTopNotificationId(x.id);
                setHiddenTopNotificationIds(getHiddenTopNotificationIds());
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
